import axios, { AxiosInstance } from "axios";
import { configurationService } from "../../appConfigService";

class HttpClient {
    private instanceValue: AxiosInstance | null = null;

    get instance(): AxiosInstance {
        if (this.instanceValue === null) {
            this.instanceValue = axios.create({
                baseURL: configurationService.configuration.baseAddress,
            });
        }

        return this.instanceValue;
    }
}

export const httpClient = new HttpClient();
